import { lazy } from "solid-js";

import { isMobile } from "@/lib/isMobile";
import Search from "@/pages/h5/search/index";

const PCGameDetail = lazy(() => import("@/pages/pc/gamedetail"));

const MyProfile = lazy(() => import("@/pages/h5/myProfile/index"));

const H5GameDetail = lazy(() => import("@/pages/h5/gamedetail"));

export interface ModalProps {
  onClose?: () => void;
  params?: Record<string, unknown>;
  isDialog?: boolean;
}

// Define modal components
export const getModals = () => {
  // 预加载组件 - 在模块加载时立即开始导入
  // const loginPromise = isMobile()
  //   ? import("@/pages/h5/login/index")
  //   : import("@/pages/pc/login/index");
  // const registerPromise = isMobile()
  //   ? import("@/pages/h5/register/index")
  //   : import("@/pages/pc/register/index");
  // const gamelistPromise = import("@/pages/h5/gamelist");
  // const depositPromise = isMobile()
  //   ? import("@/pages/pc/wallet/deposit").then((mod) => ({
  //       default: mod.H5DepositPage,
  //     }))
  //   : import("@/pages/pc/wallet/deposit").then((mod) => ({
  //       default: mod.DepositModal,
  //     }));

  // 创建预加载的懒加载组件
  const LoginComponent = lazy(() =>
    isMobile()
      ? import("@/pages/h5/login/index")
      : import("@/pages/pc/login/index"),
  );
  const RegisterComponent = lazy(() =>
    isMobile()
      ? import("@/pages/h5/register/index")
      : import("@/pages/pc/register/index"),
  );
  const GamelistComponent = lazy(() => import("@/pages/h5/gamelist"));

  const DepositComponent = lazy(() =>
    isMobile()
      ? import("@/pages/pc/wallet/deposit").then((mod) => ({
          default: mod.H5DepositPage,
        }))
      : import("@/pages/pc/wallet/deposit").then((mod) => ({
          default: mod.DepositModal,
        })),
  );
  return {
    // 登入
    login: () => LoginComponent,

    // 重置密码
    reset: lazy(() =>
      isMobile() ? import("@/pages/h5/reset") : import("@/pages/pc/reset"),
    ),
    // 注册
    register: () => RegisterComponent,
    // 活动规则
    rule: lazy(() =>
      isMobile()
        ? import("@/components/H5/Modals/ActRule")
        : import("@/components/PC/Modals/ActRule"),
    ),
    // 存款
    deposit: DepositComponent,
    // 提款
    withdraw: lazy(() =>
      isMobile()
        ? import("@/pages/h5/wallet/withdraw")
        : import("@/pages/pc/wallet/withdraw").then((mod) => ({
            default: mod.WithdrawModal,
          })),
    ),
    // 奖金规则
    "bonus-rule": lazy(() =>
      isMobile()
        ? import("@/pages/h5/bonusrule")
        : import("@/pages/pc/bonusrule"),
    ),

    "bet-detail": lazy(() =>
      isMobile()
        ? import("@/components/H5/Wallet/BetDetail")
        : import("@/components/PC/Wallet/BetDetail"),
    ),

    // // 热门游戏
    "hot-game": lazy(() => import("@/pages/h5/menu/hotGame")),
    // // 收藏游戏
    collections: lazy(() => import("@/pages/h5/menu/collections")),
    // // 近期游戏
    "recent-game": lazy(() => import("@/pages/h5/menu/recentGame")),

    // // 奖金游戏
    // "bonus-game": lazy(() => import("@/pages/pc/menu/bonusGame")),
    // // vip
    vip: lazy(() => import("@/pages/h5/vip")),
    // // 奖金中心
    // "bonus-center": lazy(() => import("@/pages/h5/bonuscenter/bonuscenter.tsx")),

    // 通知
    notify: lazy(() => import("../pages/pc/notify/notify.tsx")),

    // 游戏详情
    "game-detail": isMobile() ? H5GameDetail : PCGameDetail,
    // 游戏列表
    "game-list": GamelistComponent,
    // 厂商页面
    // providers: lazy(() => import("@/pages/h5/providers")),
    // 猜你喜欢
    personalized: lazy(() => import("@/pages/h5/personalizedGames")),
    // 全局搜索
    search: Search,
    // 道具列表
    propsList: lazy(() => import("@/pages/h5/bonuscenter/propsList/index")),

    // waleet
    "wallet/transaction": lazy(() => import("@/pages/h5/wallet/transaction")),
    "wallet/betHistory": lazy(() => import("@/pages/h5/wallet/betHistory")),

    // 个人资料页面
    "my-profile": MyProfile,

    // 锦标赛
    "tournament-detail": lazy(
      () => import("@/components/Dialogs/Tournament/index"),
    ),
  } as const;
};

// 标记仅在H5端以模态框形式显示的路由
const h5Modals = [
  "game-list",
  "vip",
  "notify",
  "hot-game",
  "collections",
  "recent-game",
] as const;

// const MODAL_ROUTES_ONLY_RENDER_ON_H5 = [
//   "providers" /** 厂商页面 */,
//   "game-list" /** 游戏列表 */,
// ];

// Helper function to check if a path is a modal path
export const checkModalPath = (path: string | null): boolean => {
  const modals = getModals();
  if (!path) return false;
  // 移除 ? 和 # 及其后面的内容
  const cleanPath = path.split(/[?#]/)[0];
  const modalTypes = Object.keys(modals);
  const pathParts = cleanPath.split("/").filter(Boolean);
  if (
    !isMobile() &&
    h5Modals.includes(pathParts[0] as (typeof h5Modals)[number])
  ) {
    return false;
  }
  return modalTypes.some((type) => {
    return pathParts[0] === type;
  });
};

export function trimPath(path: string): string {
  const indexQ = path.indexOf("?");
  const indexH = path.indexOf("#");
  // 找到最先出现的位置
  const cutIndex = Math.min(
    indexQ === -1 ? Infinity : indexQ,
    indexH === -1 ? Infinity : indexH,
  );

  // 如果没有找到 `?` 或 `#`，返回原路径
  if (cutIndex === Infinity) {
    return path;
  }

  return path.slice(0, cutIndex);
}
